import styled from 'styled-components'
import { Box, theme } from '@dasa-health/components-react'

export const Container = styled.div`
    display: flex;
    width: 100%;
    flex-direction: column;
    align-items: center;
`

export const Img = styled.img`
    width: 10rem;
    height: 18rem;

    position: absolute;
    margin-top: -3.4375rem;

    @media screen and (min-width: ${theme.breakpoints[0]}) {
        width: 20.9375rem;
        height: 25rem;
        right: 1.875rem;
    }

    @media screen and (min-width: ${theme.breakpoints[1]}) {
        width: 22.5425rem;
        height: 37.9988rem;
        right: 3rem;
    }

    @media screen and (min-width: 71.25rem) {
        right: 14rem;
    }

    @media screen and (min-width: 78.875rem) {
        right: 11rem;
    }
`

export const Content = styled.div`
    background-color: #0037ff;
    padding: 0 1rem 0 1rem;
    display: flex;
    flex-direction: column;
    align-items: center;

    @media screen and (min-width: ${theme.breakpoints[0]}) {
        width: 100%;
        height: 18.25rem;
        padding: 0;
    }
    @media screen and (min-width: ${theme.breakpoints[1]}) {
        height: 26.75rem;
    }
`

export const BoxText = styled(Box)`
    width: 100%;
    &&& {
        margin-top: 14.875rem;
    }

    p:first-child {
        font-weight: 700;
        font-size: 1.5rem;
        line-height: 2rem;
        color: #fefefe;
        margin-bottom: 1rem;
    }

    p:nth-child(2) {
        font-weight: 400;
        font-size: 0.8125rem;
        line-height: 1.375rem;
        color: #fefefe;
        padding-right: 0.625rem;
        margin-bottom: 1rem;
    }

    @media screen and (min-width: ${theme.breakpoints[0]}) {
        width: 20.9375rem;
        &&& {
            margin-top: 2rem;
            margin-right: 14.5rem;
            margin-bottom: 0.75rem;
        }

        p:first-child {
            margin-bottom: 0.75rem;
        }

        p:nth-child(2) {
            padding: 0;
        }
    }

    @media screen and (min-width: ${theme.breakpoints[1]}) {
        width: 33.6875rem;
        &&& {
            margin-top: 4.375rem;
            margin-bottom: 2.5rem;
            margin-right: 19rem;
        }

        p:first-child {
            font-size: 1.5rem;
            margin-bottom: 2rem;
        }

        p:nth-child(2) {
            font-size: 1rem;
            line-height: 1.5rem;
        }
    }
`

export const ButtonsBox = styled(Box)`
    width: 100%;
    display: flex;
    gap: 0.5rem;
    &&& {
        margin-bottom: 2.75rem;
    }

    a {
        display: inherit;
        width: 100%;
    }

    button {
        background-color: #fefefe;
        color: #0037ff;
        flex: 1;
        height: 2rem;
    }

    button:hover {
        background-color: rgb(0, 47, 219);
        color: #fefefe;
    }

    @media screen and (min-width: ${theme.breakpoints[0]}) {
        width: 20.9375rem;
        &&& {
            margin-right: 14.5rem;
        }

        a {
            width: auto;
        }

        button {
            width: 10rem;
        }
    }

    @media screen and (min-width: ${theme.breakpoints[1]}) {
        &&& {
            margin-right: 32rem;
        }

        button {
            width: 12.625rem;
            height: 3rem;
        }
    }
`
